const doc = [({"en":({"js":({"save_modes":({"save":"Save", "save_and_close":"Save & close", "cancel":"Cancel"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;